<template>
<div>
  <a href="#"  @click="consultationSlotClick">
    <img src="http://www.xdf.cn/zhuanti/school/wapm8.27/m1/img/xtb4.png" alt=""/>
    <span>咨询</span>
  </a>
<!--<slot ></slot>-->
</div>
</template>
<script>
  import {consultationFactory} from '../src/consultation';
    export default{
        props: ['schoolid'],
        data: function () {
            return {
              consultationData:consultationFactory.findById(this.schoolid)
            }
        },
        methods: {
          consultationSlotClick(){
            consultationFactory.openHref(this.consultationData);
          }
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/FooterConsultationInfo.vue